/**
 * What the app shell does with the answer to GET /api/users/me. Only a refused session
 * (401) signs someone out; a rate limit, a restart during a deploy or a network blip keeps
 * the token, so nobody is sent back to the sign-in page for a hiccup.
 */
export async function readCurrentUser(res: Response, dropToken: () => void): Promise<any | null> {
  if (res.status === 401) {
    dropToken();
    return null;
  }
  if (!res.ok) return null;
  try {
    return await res.json();
  } catch {
    return null;
  }
}
